import { Container } from "react-bootstrap";
import CardCustom from "../../components/CardCustom/CardCustom";
import Titles from "../../components/Titles/Titles";
import "./spectacles.css";

const Spectacles = ({ spectacles }) => {
	const spectacleSorted = spectacles && spectacles.sort((a, b) => a.order - b.order) || [];
	return (
		<Container>
			<div className="containerSpectacles">
				<Titles title={"SPECTACLES"} color={"white"} />

				<div className="spectacles">
					{spectacleSorted.map((spectacle, index) => (
						<CardCustom
							key={index}
							index={index}
							spectacle={spectacle}
							url={`detail/${spectacle.id}`}
							bg={"var(--bg-violet-clair)"}
						/>
					))}
				</div>
				{spectacleSorted.length === 0 && (
					<p style={{ color: "white", textAlign: "center", fontSize: "18px", marginTop: "40px" }}>
						Aucun spectacle pour le moment. <br/>
						Revenez bientôt pour découvrir nos créations en cours !
					</p>
				)}
			</div>
		</Container>
	);
};

export default Spectacles;
